<template>
  <v-data-table
    :headers="headers"
    :items="tests"
    sort-by="testNumber"
    :search="search"
    class="elevation-1"
    v-model="selected"
    item-key="testNumber"
    multi-sort
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Search"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
        ></v-text-field>

        <v-dialog
          v-model="dialogDelete"
          max-width="500px"
        >
          <v-card>
            <v-card-title
              class="headline"
              style="word-break: break-word"
            >
              Are you sure you want to delete this certificate?
            </v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                text
                @click="closeDelete"
              >
                Cancel
              </v-btn>

              <v-btn
                color="error"
                dark
                @click="confirmDelete"
              >
                OK
              </v-btn>

              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEdit" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Edit Test</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.oxygen"
                      label="Oxygen"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.nitrogen"
                      label="Nitrogen"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.carbonDioxide"
                      label="Carbon Dioxide"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.carbonMonoxide"
                      label="Carbon Monoxide"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.methane"
                      label="Methane"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.dewPoint"
                      label="Dew Point"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.waterVapor"
                      label="Water Vapor"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.nitrogenDioxide"
                      label="Nitrogen Dioxide"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.nitricOxide"
                      label="Nitric Oxide"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.sulfurDioxide"
                      label="Sulfur Dioxide"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.nitrousOxide"
                      label="NitrousOxide"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.thc"
                      label="THC"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.haloSolvents"
                      label="Halo. Solvents"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.vhc"
                      label="VHC"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.vhhc"
                      label="VHHC"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.oilParticles"
                      label="Oil & Particles"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                  >
                    <v-text-field
                      v-model="previewedItem.odor"
                      label="Odor"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col
                    cols="12"
                  >
                    <v-textarea
                      v-model="previewedItem.notes"
                      rows="2"
                      label="Notes"
                    >
                    </v-textarea>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                text
                @click="dialogEdit = false"
              >
                Cancel
              </v-btn>

              <v-btn
                color="primary"
                dark
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogTechConfirm"
          max-width="500px"
        >
          <v-card>
            <v-card-title class="headline">
              Please enter your credentials
            </v-card-title>

            <v-card-text>
              <v-text-field
                v-model="lftech.username"
                label="Username"
                ref="username"
                autofocus
              ></v-text-field>

              <v-text-field
                v-model="lftech.password"
                label="Password"
                :type="passwordShow ? 'text' : 'password'"
                :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="passwordShow = !passwordShow"
                @keyup.enter.native="techConfirmed()"
              ></v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                text
                color="primary"
                @click="closeTech()"
              >
                Cancel
              </v-btn>

              <v-btn
                color="primary"
                dark
                @click="techConfirmed()"
              >
                OK
              </v-btn>
              
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogValidation"
          max-width="800px"
        >
          <v-card>
            <v-card-title class="headline">
              Verify the validation
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  sm="3"
                >
                  <v-card>
                    <v-card-text class="py-1">
                      <div>Oxygen</div>
                      <p class="subtitle-2 text--primary mb-0">
                        {{ previewedItem.oxygen }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  sm="3"
                >
                  <v-card>
                    <v-card-text class="py-1">
                      <div>Carbon Dioxide</div>
                      <p class="subtitle-2 text--primary mb-0">
                        {{ previewedItem.carbonDioxide }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  sm="3"
                >
                  <v-card>
                    <v-card-text class="py-1">
                      <div>Carbon Monoxide</div>
                      <p class="subtitle-2 text--primary mb-0">
                        {{ previewedItem.carbonMonoxide }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  sm="3"
                >
                  <v-card>
                    <v-card-text class="py-1">
                      <div>Methane</div>
                      <p class="subtitle-2 text--primary mb-0">
                        {{ previewedItem.methane }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-row class="mb-1">
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-btn
                    dark
                    block
                    color="error"
                    class="pa-4"
                    style="width: 100%; height: 100%;"
                    @click="validationSelect('FAIL')"
                  >
                    <v-col cols="12">
                      <v-row
                        width="100%"
                        style="place-content: center; margin-bottom: 12px;"
                      >
                        <v-icon large>
                          mdi-exclamation
                        </v-icon>
                      </v-row>

                      <v-row width="100%" style="place-content: center">
                        <span class="subtitle-1 font-weight-medium">
                          Fail
                        </span>
                      </v-row>
                    </v-col>
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-btn
                    dark
                    block
                    color="success"
                    class="pa-4"
                    style="width: 100%; height: 100%;"
                    @click="validationSelect('PASS')"
                  >
                    <v-col cols="12">
                      <v-row
                        width="100%"
                        style="place-content: center; margin-bottom: 12px;"
                      >
                        <v-icon large>
                          mdi-check
                        </v-icon>
                      </v-row>

                      <v-row width="100%" style="place-content: center">
                        <span class="subtitle-1 font-weight-medium">
                          Pass
                        </span>
                      </v-row>
                    </v-col>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogPreviewCert"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-app-bar
              fixed
              dark
              color="primary"
              rounded=0
            >
              <v-toolbar-title>Cert Preview</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu
                offset-y
              >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    icon
                    dark
                    :loading="pdfProgress < 100"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    link
                    disabled
                    v-if="!approvalDone"
                  >
                    <v-list-item-title>
                      <v-icon
                        left
                        color="error"
                      >
                        mdi-exclamation
                      </v-icon>
                      Quarantine
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="dialogEdit = true"
                    v-if="checkRole('ROLE_LFADMIN') && !approvalDone"
                  >
                    <v-list-item-title>
                      <v-icon
                        left
                        color="info"
                      >
                        mdi-square-edit-outline
                      </v-icon>
                      Edit
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="generateReport()"
                    v-if="!approvalDone"
                  >
                    <v-list-item-title>
                      <v-icon
                        left
                        color="success"
                      >
                        mdi-check
                      </v-icon>
                      Approve
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="dialogSendResults = true"
                    v-if="approvalDone"
                  >
                    <v-list-item-title>
                      <v-icon left>
                        mdi-email-send-outline
                      </v-icon>
                      Resend
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="downloadCert(previewedItem.testNumber)"
                    v-if="approvalDone"
                  >
                    <v-list-item-title>
                      <v-icon left>
                        mdi-download-outline
                      </v-icon>
                      Download
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn
                icon
                dark
                @click="close"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>

            <v-main class="px-0">
              <div>
                <div id="preview">
                  <!-- Background Image -->
                  <div>
                    <div v-if="previewedItem.lol.unaccredited">
                      <img id="previewimg" src="/static/img/cert/cert-unaccredited.png" width="100%" />
                    </div>
                    <div v-else-if="previewedItem.standard.standardName == 'NFPA 1989 (2019)' && previewedItem.passfail.final != 'FAIL' && !previewedItem.beforeAfter">
                      <img id="previewimg" src="/static/img/cert/cert-nfpa-1.png" width="100%" />
                    </div>
                    <div v-else-if="previewedItem.standard.standardName == 'NFPA 1989 (2019)' && previewedItem.passfail.final != 'FAIL'">
                      <img id="previewimg" src="/static/img/cert/cert-nfpa-1-beforeafter.png" width="100%" />
                    </div>
                    <div v-else-if="previewedItem.passfail.final == 'FAIL'">
                      <img id="previewimg" src="/static/img/cert/cert-fail.png" width="100%" />
                    </div>
                    <div v-else>
                      <img id="previewimg" src="/static/img/cert/cert.png" width="100%" />
                    </div>
                  </div>

                  <!-- Client Data -->
                  <div>
                    <span id="previewclient">{{ previewedItem.client.customerName }}</span>
                    <span id="previewclientid"></span>
                    <span id="previewlocationdescription">{{ previewedItem.location.locationDescription }}</span>
                    <span id="previewlocationaddress">
                      <span v-if="previewedItem.location.locationAddress">
                        {{ previewedItem.location.locationAddress }}<br />
                      </span>
                      <span v-if="previewedItem.location.locationAddress2">
                        {{ previewedItem.location.locationAddress2 }}<br />
                      </span>
                      <span v-if="previewedItem.location.locationCity">
                        {{ previewedItem.location.locationCity }},&nbsp;
                      </span>
                      <span v-if="previewedItem.location.locationState">
                        {{ previewedItem.location.locationState }}&nbsp;
                      </span>
                      <span v-if="previewedItem.location.locationZip">
                        {{ previewedItem.location.locationZip }}
                      </span>
                    </span>
                    <span id="previewsourcemake">{{ previewedItem.source.sourceMake }}</span>
                    <span id="previewsourcemodel">{{ previewedItem.source.sourceModel }}</span>
                    <span id="previewsourcesn">{{ previewedItem.source.sourceSN }}</span>
                    <span id="previewsourcedescription">{{ previewedItem.source.sourceDescription }}</span>
                    <div v-if="!previewedItem.beforeAfter">
                      <span id="previewnexttestdate">{{ previewedItem.nextTestDate }}</span>
                    </div>
                    <div v-else>
                      <span id="previewbeforeafter">{{ previewedItem.beforeAfter }}</span>
                      <span id="previewnexttestdatebeforeafter">{{ previewedItem.nextTestDate }}</span>
                    </div>
                  </div>

                  <!-- Results Header Data -->
                  <div>
                    <span id="previewstandard">{{ previewedItem.standard.standardName }}</span>
                    <span id="previewstandardcomboa" style="display: none;">[StandardA]</span>
                    <span id="previewstandardcombob" style="display: none;">[StandardB]</span>
                    <span id="previewfrequency">{{ previewedItem.frequency.frequencyName }}</span>
                    <span id="previewadvisedfrequency"></span>
                  </div>

                  <!-- Results Data -->
                  <div>
                    <div id="previewanalytes">
                      <span id="previewanalytesoxygen">Oxygen</span>
                      <span id="previewanalytesnitrogen">Nitrogen</span>
                      <span id="previewanalytescarbondioxide">Carbon Dioxide</span>
                      <span id="previewanalytescarbonmonoxide">Carbon Monoxide</span>
                      <span id="previewanalytesmethane">Methane</span>
                      <span id="previewanalytesdewpoint">Dew Point</span>
                      <span id="previewanalyteswatervapor">Water Vapor</span>
                      <span id="previewanalytesnitrogendioxide">Nitrogen Dioxide</span>
                      <span id="previewanalytesnitricoxide">Nitric Oxide</span>
                      <span id="previewanalytessulfurdioxide">Sulfur Dioxide</span>
                      <span id="previewanalytesnitrousoxide">Nitrous Oxide</span>
                      <span id="previewanalytesthc">THC</span>
                      <span id="previewanalyteshalosolvents">Halo. Solvents</span>
                      <span id="previewanalytesvhc">VHC</span>
                      <span id="previewanalytesvhhc">VHHC</span>
                      <span id="previewanalytesoilparticles">Oil & Particles</span>
                      <span id="previewanalytesodor">Odor</span>
                    </div>

                    <div id="previewresults">
                      <span id="previewresultsoxygen">
                        {{ previewedItem.sampleshow.oxygen ? previewedItem.oxygen : 'NA' }}
                      </span>
                      <span id="previewresultsnitrogen">
                        {{ previewedItem.sampleshow.nitrogen ? previewedItem.nitrogen : 'NA' }}
                      </span>
                      <span id="previewresultscarbondioxide">
                        {{ previewedItem.sampleshow.carbonDioxide ? previewedItem.carbonDioxide : 'NA' }}
                      </span>
                      <span id="previewresultscarbonmonoxide">
                        {{ previewedItem.sampleshow.carbonMonoxide ? previewedItem.carbonMonoxide : 'NA' }}
                      </span>
                      <span id="previewresultsmethane">
                        {{ previewedItem.sampleshow.methane ? previewedItem.methane : 'NA' }}
                      </span>
                      <span id="previewresultsdewpoint">
                        {{ previewedItem.sampleshow.dewPoint ? previewedItem.dewPoint : 'NA' }}
                      </span>
                      <span id="previewresultswatervapor">
                        {{ previewedItem.sampleshow.waterVapor ? previewedItem.waterVapor : 'NA' }}
                      </span>
                      <span id="previewresultsnitrogendioxide">
                        {{ previewedItem.sampleshow.nitrogenDioxide ? previewedItem.nitrogenDioxide : 'NA' }}
                      </span>
                      <span id="previewresultsnitricoxide">
                        {{ previewedItem.sampleshow.nitricOxide ? previewedItem.nitricOxide : 'NA' }}
                      </span>
                      <span id="previewresultssulfurdioxide">
                        {{ previewedItem.sampleshow.sulfurDioxide ? previewedItem.sulfurDioxide : 'NA' }}
                      </span>
                      <span id="previewresultsnitrousoxide">
                        {{ previewedItem.sampleshow.nitrousOxide ? previewedItem.nitrousOxide : 'NA' }}
                      </span>
                      <span id="previewresultsthc">
                        {{ previewedItem.sampleshow.thc ? previewedItem.thc : 'NA' }}
                      </span>
                      <span id="previewresultshalosolvents">
                        {{ previewedItem.sampleshow.haloSolvents ? previewedItem.haloSolvents : 'NA' }}
                      </span>
                      <span id="previewresultsvhc">
                        {{ previewedItem.sampleshow.vhc ? previewedItem.vhc : 'NA' }}
                      </span>
                      <span id="previewresultsvhhc">
                        {{ previewedItem.sampleshow.vhhc ? previewedItem.vhhc : 'NA' }}
                      </span>
                      <span id="previewresultsoilparticles">
                        {{ previewedItem.sampleshow.oilParticles ? previewedItem.oilParticles : 'NA' }}
                      </span>
                      <span id="previewresultsodor">
                        {{ previewedItem.standard.odor != null ? (previewedItem.odor == 0 ? 'None' : (previewedItem.odor == 1 ? 'Slight' : 'Strong')) : 'NA' }}
                      </span>
                    </div>

                    <div id="previewlimits">
                      <span id="previewlimitsoxygen" v-html="previewedItem.limit.oxygen"></span>
                      <span id="previewlimitsnitrogen" v-html="previewedItem.limit.nitrogen"></span>
                      <span id="previewlimitscarbondioxide" v-html="previewedItem.limit.carbonDioxide"></span>
                      <span id="previewlimitscarbonmonoxide" v-html="previewedItem.limit.carbonMonoxide"></span>
                      <span id="previewlimitsmethane" v-html="previewedItem.limit.methane"></span>
                      <span id="previewlimitsdewpoint" v-html="previewedItem.limit.dewPoint"></span>
                      <span id="previewlimitswatervapor" v-html="previewedItem.limit.waterVapor"></span>
                      <span id="previewlimitsnitrogendioxide" v-html="previewedItem.limit.nitrogenDioxide"></span>
                      <span id="previewlimitsnitricoxide" v-html="previewedItem.limit.nitricOxide"></span>
                      <span id="previewlimitssulfurdioxide" v-html="previewedItem.limit.sulfurDioxide"></span>
                      <span id="previewlimitsnitrousoxide" v-html="previewedItem.limit.nitrousOxide"></span>
                      <span id="previewlimitsthc" v-html="previewedItem.limit.thc"></span>
                      <span id="previewlimitshalosolvents" v-html="previewedItem.limit.haloSolvents"></span>
                      <span id="previewlimitsvhc" v-html="previewedItem.limit.vhc"></span>
                      <span id="previewlimitsvhhc" v-html="previewedItem.limit.vhhc"></span>
                      <span id="previewlimitsoilparticles" v-html="previewedItem.limit.oilParticles"></span>
                      <span id="previewlimitsodor">
                        {{ previewedItem.standard.odor != null ? (previewedItem.standard.odor == 0 ? 'None' : (previewedItem.standard.odor == 1 ? 'Slight' : 'Strong')) : 'NA' }}
                      </span>
                    </div>

                    <div id="previewlimitscomboa" style="display: none;">
                      <span id="previewlimitscomboaoxygen">[Oxygen]</span>
                      <span id="previewlimitscomboanitrogen">[Nitrogen]</span>
                      <span id="previewlimitscomboacarbondioxide">[CarbonDioxide]</span>
                      <span id="previewlimitscomboacarbonmonoxide">[CarbonMonoxide</span>
                      <span id="previewlimitscomboamethane">[Methane]</span>
                      <span id="previewlimitscomboadewpoint">[DewPoint]</span>
                      <span id="previewlimitscomboawatervapor">[WaterVapor]</span>
                      <span id="previewlimitscomboanitrogendioxide">[NitrogenDioxide]</span>
                      <span id="previewlimitscomboanitricoxide">[NitricOxide]</span>
                      <span id="previewlimitscomboasulfurdioxide">[SulfurDioxide]</span>
                      <span id="previewlimitscomboanitrousoxide">[NitrousOxide]</span>
                      <span id="previewlimitscomboathc">[THC]</span>
                      <span id="previewlimitscomboahalosolvents">[HaloSolvents]</span>
                      <span id="previewlimitscomboavhc">[VHC]</span>
                      <span id="previewlimitscomboavhhc">[VHHC]</span>
                      <span id="previewlimitscomboaoilparticles">[OilParticles]</span>
                      <span id="previewlimitscomboaodor">[Odor]</span>
                    </div>

                    <div id="previewlimitscombob" style="display: none;">
                      <span id="previewlimitscomboboxygen">[Oxygen]</span>
                      <span id="previewlimitscombobnitrogen">[Nitrogen]</span>
                      <span id="previewlimitscombobcarbondioxide">[CarbonDioxide]</span>
                      <span id="previewlimitscombobcarbonmonoxide">[CarbonMonoxide</span>
                      <span id="previewlimitscombobmethane">[Methane]</span>
                      <span id="previewlimitscombobdewpoint">[DewPoint]</span>
                      <span id="previewlimitscombobwatervapor">[WaterVapor]</span>
                      <span id="previewlimitscombobnitrogendioxide">[NitrogenDioxide]</span>
                      <span id="previewlimitscombobnitricoxide">[NitricOxide]</span>
                      <span id="previewlimitscombobsulfurdioxide">[SulfurDioxide]</span>
                      <span id="previewlimitscombobnitrousoxide">[NitrousOxide]</span>
                      <span id="previewlimitscombobthc">[THC]</span>
                      <span id="previewlimitscombobhalosolvents">[HaloSolvents]</span>
                      <span id="previewlimitscombobvhc">[VHC]</span>
                      <span id="previewlimitscombobvhhc">[VHHC]</span>
                      <span id="previewlimitscomboboilparticles">[OilParticles]</span>
                      <span id="previewlimitscombobodor">[Odor]</span>
                    </div>
                  </div>

                  <!-- Pass/Fail -->
                  <div>
                    <div id="previewpassfail">
                      <span id="previewpassfailoxygen" :style="{'color': previewedItem.passfail.oxygen == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.oxygen }}
                      </span>
                      <span id="previewpassfailnitrogen" :style="{'color': previewedItem.passfail.nitrogen == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.nitrogen }}
                      </span>
                      <span id="previewpassfailcarbondioxide" :style="{'color': previewedItem.passfail.carbonDioxide == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.carbonDioxide }}
                      </span>
                      <span id="previewpassfailcarbonmonoxide" :style="{'color': previewedItem.passfail.carbonMonoxide == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.carbonMonoxide }}
                      </span>
                      <span id="previewpassfailmethane" :style="{'color': previewedItem.passfail.methane == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.methane }}
                      </span>
                      <span id="previewpassfaildewpoint" :style="{'color': previewedItem.passfail.dewPoint == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.dewPoint }}
                      </span>
                      <span id="previewpassfailwatervapor" :style="{'color': previewedItem.passfail.waterVapor == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.waterVapor }}
                      </span>
                      <span id="previewpassfailnitrogendioxide" :style="{'color': previewedItem.passfail.nitrogenDioxide == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.nitrogenDioxide }}
                      </span>
                      <span id="previewpassfailnitricoxide" :style="{'color': previewedItem.passfail.nitricOxide == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.nitricOxide }}
                      </span>
                      <span id="previewpassfailsulfurdioxide" :style="{'color': previewedItem.passfail.sulfurDioxide == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.sulfurDioxide }}
                      </span>
                      <span id="previewpassfailnitrousoxide" :style="{'color': previewedItem.passfail.nitrousOxide == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.nitrousOxide }}
                      </span>
                      <span id="previewpassfailthc" :style="{'color': previewedItem.passfail.thc == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.thc }}
                      </span>
                      <span id="previewpassfailhalosolvents" :style="{'color': previewedItem.passfail.haloSolvents == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.haloSolvents }}
                      </span>
                      <span id="previewpassfailvhc" :style="{'color': previewedItem.passfail.vhc == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.vhc }}
                      </span>
                      <span id="previewpassfailvhhc" :style="{'color': previewedItem.passfail.vhhc == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.vhhc }}
                      </span>
                      <span id="previewpassfailoilparticles" :style="{'color': previewedItem.passfail.oilParticles == 'Fail' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.oilParticles }}
                      </span>
                      <span id="previewpassfailodor"
                        :style="{'color': previewedItem.standard.odor != null ? (previewedItem.odor ? 'red' : 'black') : 'black' }"
                      >
                        {{ previewedItem.standard.odor != null ? (previewedItem.odor ? 'Fail' : 'Pass') : 'NA' }}
                      </span>
                    </div>

                    <div id="previewfinalpassfail1">
                      <span id="previewfinalpassfail1sample" :style="{'color': previewedItem.passfail.final == 'FAIL' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.final }}
                      </span>
                    </div>

                    <div id="previewfinalpassfail2">
                      <span id="previewfinalpassfail2passfail" :style="{'color': previewedItem.passfail.final == 'FAIL' ? 'red' : 'black' }">
                        {{ previewedItem.passfail.final }}
                      </span>
                    </div>
                  </div>

                  <!-- Cert Data -->
                  <div>
                    <span id="previewlolnum">{{ previewedItem.lol.lolNumber }}</span>
                    <span id="previewunitnum">{{ previewedItem.unit.unitNumber }}</span>
                    <span id="previewdealer">{{ previewedItem.dealer.customerName }}</span>
                    <span id="previewdealerid"></span>
                    <span id="previewrequestedby">{{ previewedItem.requestedBy.fullName }}</span>
                    <span id="previewcertid">{{ previewedItem.testNumber }}</span>
                    <span id="previewsampledate">{{ previewedItem.sampleDateShow }}</span>
                    <span id="previewreceivedate">{{ previewedItem.receiveDateShow }}</span>
                    <span id="previewanalyzedate">{{ previewedItem.analyzeDateShow }}</span>
                    <span id="previewcertissuedate">{{ previewedItem.certIssueDateShow }}</span>
                    <span id="previewnotes">{{ previewedItem.notes }}</span>
                  </div>

                  <!-- Signature -->
                  <div v-if="!previewedItem.lol.unaccredited" id="previewsignaturebox">
                    <img id="previewsignature" :src="`/static/img/cert/${previewedItem.approvedBy.username}-signature.png`"/>
                    <div id="previewnametitle">
                      <span id="previewnametitledetail">{{ previewedItem.approvedBy.fullName }} / Technician</span>
                    </div>
                  </div>
                </div>

                <!-- NFPA Page 2 -->
                <div id="previewpg2" v-if="previewedItem.standard.standardName == 'NFPA 1989 (2019)' && previewedItem.passfail.final != 'FAIL'">
                  <div>
                    <img id="previewimgpg2" src="/static/img/cert/cert-nfpa-2.png" width="100%" />
                  </div>

                  <div>
                    <span id="previewnfpaclient">{{ previewedItem.client.customerName }}</span>

                    <span id="previewnfpasource">
                      <span v-if="previewedItem.source.sourceMake">
                        {{ previewedItem.source.sourceMake }}<br />
                      </span>
                      <span v-if="previewedItem.source.sourceModel">
                        {{ previewedItem.source.sourceModel }}<br />
                      </span>
                      <span v-if="previewedItem.source.sourceSN">
                        {{ previewedItem.source.sourceSN }}<br />
                      </span>
                      <span v-if="previewedItem.source.sourceDescription">
                        {{ previewedItem.source.sourceDescription }}<br />
                      </span>
                      <span>
                        {{ previewedItem.location.locationCity }}
                      </span>
                      <span v-if="previewedItem.location.locationCity && previewedItem.location.locationState">,&nbsp;</span>
                      <span>{{ previewedItem.location.locationState }}</span>
                    </span>

                    <!-- <span id="previewnfpasource">
                      <span v-if="previewedItem.location.locationDescription">
                        {{ previewedItem.location.locationDescription }}<br />
                      </span>
                      <span v-if="previewedItem.source.sourceMake">
                        {{ previewedItem.source.sourceMake }}
                      </span>
                      <span v-if="previewedItem.source.sourceMake">
                        &nbsp;
                      </span>
                      <span v-if="previewedItem.source.sourceModel">
                        {{ previewedItem.source.sourceModel }}
                      </span>
                      <span v-if="previewedItem.source.sourceMake || previewedItem.source.sourceModel">
                        &nbsp;
                      </span>
                      <span v-if="previewedItem.source.sourceSN">
                        {{ previewedItem.source.sourceSN }}<br />
                      </span>
                      <span v-if="previewedItem.source.sourceDescription">
                        {{ previewedItem.source.sourceDescription }}<br />
                      </span>
                      <span>
                        {{ previewedItem.location.locationCity }}
                      </span>
                      <span v-if="previewedItem.location.locationCity && previewedItem.location.locationState">,&nbsp;</span>
                      <span>{{ previewedItem.location.locationState }}</span>
                    </span> -->

                    <!-- <span id="previewnfpasource">
                      <span v-if="previewedItem.source.sourceMake">
                        {{ previewedItem.source.sourceMake }}<br />
                      </span>
                      <span v-if="previewedItem.source.sourceModel">
                        {{ previewedItem.source.sourceModel }}<br />
                      </span>
                      <span v-if="previewedItem.source.sourceSN">
                        {{ previewedItem.source.sourceSN }}<br />
                      </span>
                      <span v-if="previewedItem.source.sourceDescription">
                        {{ previewedItem.source.sourceDescription }}
                      </span>
                    </span> -->

                    <span id="previewnfpanexttestdate">
                      {{ previewedItem.nextTestDate }}
                    </span>
                  </div>

                  <!-- Signature -->
                  <div id="previewsignaturebox">
                    <img id="previewsignature" :src="`/static/img/cert/${previewedItem.approvedBy.username}-signature.png`"/>
                    <div id="previewnametitle">
                      <span id="previewnametitledetail">{{ previewedItem.approvedBy.fullName }} / Technician</span>
                    </div>
                  </div>
                </div>

                <!-- NFPA Page 3 -->
                <div id="previewpg3"  v-if="previewedItem.standard.standardName == 'NFPA 1989 (2019)' && previewedItem.passfail.final != 'FAIL'">
                  <div id="previewpg3">
                    <img id="previewimgpg3" src="/static/img/cert/cert-nfpa-3.png" width="100%" />
                  </div>
                </div>
              </div>

              <div>
                <vue-html2pdf
                  :show-layout="false"
                  :float-layout="true"
                  :enable-download="false"
                  :preview-modal="true"
                  :paginate-elements-by-height="816"
                  :filename="previewedItem.testNumber"
                  :pdf-quality="2"
                  :manual-pagination="true"
                  pdf-format="letter"
                  pdf-orientation="landscape"
                  pdf-content-width="1052px"
                  @progress="onProgress($event)"
                  @hasDownloaded="hasDownloaded($event)"
                  ref="lolCertificate"
                >
                  <section slot="pdf-content">
                    <div>
                      <div id="cert">
                        <div>
                          <div v-if="previewedItem.lol.unaccredited">
                            <img id="certimg" src="/static/img/cert/cert-unaccredited.png" width="100%" />
                          </div>
                          <div v-else-if="previewedItem.standard.standardName == 'NFPA 1989 (2019)' && previewedItem.passfail.final != 'FAIL' && !previewedItem.beforeAfter">
                            <img id="certimg" src="/static/img/cert/cert-nfpa-1.png" width="100%" />
                          </div>
                          <div v-else-if="previewedItem.standard.standardName == 'NFPA 1989 (2019)' && previewedItem.passfail.final != 'FAIL'">
                            <img id="certimg" src="/static/img/cert/cert-nfpa-1-beforeafter.png" width="100%" />
                          </div>
                          <div v-else-if="previewedItem.passfail.final == 'FAIL'">
                            <img id="certimg" src="/static/img/cert/cert-fail.png" width="100%" />
                          </div>
                          <div v-else>
                            <img id="certimg" src="/static/img/cert/cert.png" width="100%" />
                          </div>
                        </div>

                        <!-- Client Data -->
                        <div>
                          <span id="certclient">{{ previewedItem.client.customerName }}</span>
                          <span id="certclientid"></span>
                          <span id="certlocationdescription">{{ previewedItem.location.locationDescription }}</span>
                          <span id="certlocationaddress">
                            <span v-if="previewedItem.location.locationAddress">
                              {{ previewedItem.location.locationAddress }}<br />
                            </span>
                            <span v-if="previewedItem.location.locationAddress2">
                              {{ previewedItem.location.locationAddress2 }}<br />
                            </span>
                            <span v-if="previewedItem.location.locationCity">
                              {{ previewedItem.location.locationCity }},&nbsp;
                            </span>
                            <span v-if="previewedItem.location.locationState">
                              {{ previewedItem.location.locationState }}&nbsp;
                            </span>
                            <span v-if="previewedItem.location.locationZip">
                              {{ previewedItem.location.locationZip }}
                            </span>
                          </span>
                          <span id="certsourcemake">{{ previewedItem.source.sourceMake }}</span>
                          <span id="certsourcemodel">{{ previewedItem.source.sourceModel }}</span>
                          <span id="certsourcesn">{{ previewedItem.source.sourceSN }}</span>
                          <span id="certsourcedescription">{{ previewedItem.source.sourceDescription }}</span>
                          <div v-if="!previewedItem.beforeAfter">
                            <span id="certnexttestdate">{{ previewedItem.nextTestDate }}</span>
                          </div>
                          <div v-else>
                            <span id="certbeforeafter">{{ previewedItem.beforeAfter }}</span>
                            <span id="certnexttestdatebeforeafter">{{ previewedItem.nextTestDate }}</span>
                          </div>
                        </div>

                        <!-- Results Header Data -->
                        <div>
                          <span id="certstandard">{{ previewedItem.standard.standardName }}</span>
                          <span id="certstandardcomboa" style="display: none;">[StandardA]</span>
                          <span id="certstandardcombob" style="display: none;">[StandardB]</span>
                          <span id="certfrequency">{{ previewedItem.frequency.frequencyName }}</span>
                          <span id="certadvisedfrequency"></span>
                        </div>

                        <!-- Results Data -->
                        <div>
                          <div id="certanalytes">
                            <span id="certanalytesoxygen">Oxygen</span>
                            <span id="certanalytesnitrogen">Nitrogen</span>
                            <span id="certanalytescarbondioxide">Carbon Dioxide</span>
                            <span id="certanalytescarbonmonoxide">Carbon Monoxide</span>
                            <span id="certanalytesmethane">Methane</span>
                            <span id="certanalytesdewpoint">Dew Point</span>
                            <span id="certanalyteswatervapor">Water Vapor</span>
                            <span id="certanalytesnitrogendioxide">Nitrogen Dioxide</span>
                            <span id="certanalytesnitricoxide">Nitric Oxide</span>
                            <span id="certanalytessulfurdioxide">Sulfur Dioxide</span>
                            <span id="certanalytesnitrousoxide">Nitrous Oxide</span>
                            <span id="certanalytesthc">THC</span>
                            <span id="certanalyteshalosolvents">Halo. Solvents</span>
                            <span id="certanalytesvhc">VHC</span>
                            <span id="certanalytesvhhc">VHHC</span>
                            <span id="certanalytesoilparticles">Oil & Particles</span>
                            <span id="certanalytesodor">Odor</span>
                          </div>

                          <div id="certresults">
                            <span id="certresultsoxygen">
                              {{ previewedItem.sampleshow.oxygen ? previewedItem.oxygen : 'NA' }}
                            </span>
                            <span id="certresultsnitrogen">
                              {{ previewedItem.sampleshow.nitrogen ? previewedItem.nitrogen : 'NA' }}
                            </span>
                            <span id="certresultscarbondioxide">
                              {{ previewedItem.sampleshow.carbonDioxide ? previewedItem.carbonDioxide : 'NA' }}
                            </span>
                            <span id="certresultscarbonmonoxide">
                              {{ previewedItem.sampleshow.carbonMonoxide ? previewedItem.carbonMonoxide : 'NA' }}
                            </span>
                            <span id="certresultsmethane">
                              {{ previewedItem.sampleshow.methane ? previewedItem.methane : 'NA' }}
                            </span>
                            <span id="certresultsdewpoint">
                              {{ previewedItem.sampleshow.dewPoint ? previewedItem.dewPoint : 'NA' }}
                            </span>
                            <span id="certresultswatervapor">
                              {{ previewedItem.sampleshow.waterVapor ? previewedItem.waterVapor : 'NA' }}
                            </span>
                            <span id="certresultsnitrogendioxide">
                              {{ previewedItem.sampleshow.nitrogenDioxide ? previewedItem.nitrogenDioxide : 'NA' }}
                            </span>
                            <span id="certresultsnitricoxide">
                              {{ previewedItem.sampleshow.nitricOxide ? previewedItem.nitricOxide : 'NA' }}
                            </span>
                            <span id="certresultssulfurdioxide">
                              {{ previewedItem.sampleshow.sulfurDioxide ? previewedItem.sulfurDioxide : 'NA' }}
                            </span>
                            <span id="certresultsnitrousoxide">
                              {{ previewedItem.sampleshow.nitrousOxide ? previewedItem.nitrousOxide : 'NA' }}
                            </span>
                            <span id="certresultsthc">
                              {{ previewedItem.sampleshow.thc ? previewedItem.thc : 'NA' }}
                            </span>
                            <span id="certresultshalosolvents">
                              {{ previewedItem.sampleshow.haloSolvents ? previewedItem.haloSolvents : 'NA' }}
                            </span>
                            <span id="certresultsvhc">
                              {{ previewedItem.sampleshow.vhc ? previewedItem.vhc : 'NA' }}
                            </span>
                            <span id="certresultsvhhc">
                              {{ previewedItem.sampleshow.vhhc ? previewedItem.vhhc : 'NA' }}
                            </span>
                            <span id="certresultsoilparticles">
                              {{ previewedItem.sampleshow.oilParticles ? previewedItem.oilParticles : 'NA' }}
                            </span>
                            <span id="certresultsodor">
                              {{ previewedItem.standard.odor != null ? (previewedItem.odor == 0 ? 'None' : (previewedItem.odor == 1 ? 'Slight' : 'Strong')) : 'NA' }}
                            </span>
                          </div>

                          <div id="certlimits">
                            <span id="certlimitsoxygen" v-html="previewedItem.limit.oxygen"></span>
                            <span id="certlimitsnitrogen" v-html="previewedItem.limit.nitrogen"></span>
                            <span id="certlimitscarbondioxide" v-html="previewedItem.limit.carbonDioxide"></span>
                            <span id="certlimitscarbonmonoxide" v-html="previewedItem.limit.carbonMonoxide"></span>
                            <span id="certlimitsmethane" v-html="previewedItem.limit.methane"></span>
                            <span id="certlimitsdewpoint" v-html="previewedItem.limit.dewPoint"></span>
                            <span id="certlimitswatervapor" v-html="previewedItem.limit.waterVapor"></span>
                            <span id="certlimitsnitrogendioxide" v-html="previewedItem.limit.nitrogenDioxide"></span>
                            <span id="certlimitsnitricoxide" v-html="previewedItem.limit.nitricOxide"></span>
                            <span id="certlimitssulfurdioxide" v-html="previewedItem.limit.sulfurDioxide"></span>
                            <span id="certlimitsnitrousoxide" v-html="previewedItem.limit.nitrousOxide"></span>
                            <span id="certlimitsthc" v-html="previewedItem.limit.thc"></span>
                            <span id="certlimitshalosolvents" v-html="previewedItem.limit.haloSolvents"></span>
                            <span id="certlimitsvhc" v-html="previewedItem.limit.vhc"></span>
                            <span id="certlimitsvhhc" v-html="previewedItem.limit.vhhc"></span>
                            <span id="certlimitsoilparticles" v-html="previewedItem.limit.oilParticles"></span>
                            <span id="certlimitsodor">
                              {{ previewedItem.standard.odor != null ? (previewedItem.standard.odor == 0 ? 'None' : (previewedItem.standard.odor == 1 ? 'Slight' : 'Strong')) : 'NA' }}
                            </span>
                          </div>

                          <div id="certlimitscomboa" style="display: none;">
                            <span id="certlimitscomboaoxygen">[Oxygen]</span>
                            <span id="certlimitscomboanitrogen">[Nitrogen]</span>
                            <span id="certlimitscomboacarbondioxide">[CarbonDioxide]</span>
                            <span id="certlimitscomboacarbonmonoxide">[CarbonMonoxide</span>
                            <span id="certlimitscomboamethane">[Methane]</span>
                            <span id="certlimitscomboadewpoint">[DewPoint]</span>
                            <span id="certlimitscomboawatervapor">[WaterVapor]</span>
                            <span id="certlimitscomboanitrogendioxide">[NitrogenDioxide]</span>
                            <span id="certlimitscomboanitricoxide">[NitricOxide]</span>
                            <span id="certlimitscomboasulfurdioxide">[SulfurDioxide]</span>
                            <span id="certlimitscomboanitrousoxide">[NitrousOxide]</span>
                            <span id="certlimitscomboathc">[THC]</span>
                            <span id="certlimitscomboahalosolvents">[HaloSolvents]</span>
                            <span id="certlimitscomboavhc">[VHC]</span>
                            <span id="certlimitscomboavhhc">[VHHC]</span>
                            <span id="certlimitscomboaoilparticles">[OilParticles]</span>
                            <span id="certlimitscomboaodor">[Odor]</span>
                          </div>

                          <div id="certlimitscombob" style="display: none;">
                            <span id="certlimitscomboboxygen">[Oxygen]</span>
                            <span id="certlimitscombobnitrogen">[Nitrogen]</span>
                            <span id="certlimitscombobcarbondioxide">[CarbonDioxide]</span>
                            <span id="certlimitscombobcarbonmonoxide">[CarbonMonoxide</span>
                            <span id="certlimitscombobmethane">[Methane]</span>
                            <span id="certlimitscombobdewpoint">[DewPoint]</span>
                            <span id="certlimitscombobwatervapor">[WaterVapor]</span>
                            <span id="certlimitscombobnitrogendioxide">[NitrogenDioxide]</span>
                            <span id="certlimitscombobnitricoxide">[NitricOxide]</span>
                            <span id="certlimitscombobsulfurdioxide">[SulfurDioxide]</span>
                            <span id="certlimitscombobnitrousoxide">[NitrousOxide]</span>
                            <span id="certlimitscombobthc">[THC]</span>
                            <span id="certlimitscombobhalosolvents">[HaloSolvents]</span>
                            <span id="certlimitscombobvhc">[VHC]</span>
                            <span id="certlimitscombobvhhc">[VHHC]</span>
                            <span id="certlimitscomboboilparticles">[OilParticles]</span>
                            <span id="certlimitscombobodor">[Odor]</span>
                          </div>
                        </div>

                        <!-- Pass/Fail -->
                        <div>
                          <div id="certpassfail">
                            <span id="certpassfailoxygen" :style="{'color': previewedItem.passfail.oxygen == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.oxygen }}
                            </span>
                            <span id="certpassfailnitrogen" :style="{'color': previewedItem.passfail.nitrogen == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.nitrogen }}
                            </span>
                            <span id="certpassfailcarbondioxide" :style="{'color': previewedItem.passfail.carbonDioxide == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.carbonDioxide }}
                            </span>
                            <span id="certpassfailcarbonmonoxide" :style="{'color': previewedItem.passfail.carbonMonoxide == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.carbonMonoxide }}
                            </span>
                            <span id="certpassfailmethane" :style="{'color': previewedItem.passfail.methane == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.methane }}
                            </span>
                            <span id="certpassfaildewpoint" :style="{'color': previewedItem.passfail.dewPoint == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.dewPoint }}
                            </span>
                            <span id="certpassfailwatervapor" :style="{'color': previewedItem.passfail.waterVapor == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.waterVapor }}
                            </span>
                            <span id="certpassfailnitrogendioxide" :style="{'color': previewedItem.passfail.nitrogenDioxide == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.nitrogenDioxide }}
                            </span>
                            <span id="certpassfailnitricoxide" :style="{'color': previewedItem.passfail.nitricOxide == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.nitricOxide }}
                            </span>
                            <span id="certpassfailsulfurdioxide" :style="{'color': previewedItem.passfail.sulfurDioxide == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.sulfurDioxide }}
                            </span>
                            <span id="certpassfailnitrousoxide" :style="{'color': previewedItem.passfail.nitrousOxide == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.nitrousOxide }}
                            </span>
                            <span id="certpassfailthc" :style="{'color': previewedItem.passfail.thc == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.thc }}
                            </span>
                            <span id="certpassfailhalosolvents" :style="{'color': previewedItem.passfail.haloSolvents == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.haloSolvents }}
                            </span>
                            <span id="certpassfailvhc" :style="{'color': previewedItem.passfail.vhc == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.vhc }}
                            </span>
                            <span id="certpassfailvhhc" :style="{'color': previewedItem.passfail.vhhc == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.vhhc }}
                            </span>
                            <span id="certpassfailoilparticles" :style="{'color': previewedItem.passfail.oilParticles == 'Fail' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.oilParticles }}
                            </span>
                            <span id="certpassfailodor"
                              :style="{'color': previewedItem.standard.odor != null ? (previewedItem.odor ? 'red' : 'black') : 'black' }"
                            >
                              {{ previewedItem.standard.odor != null ? (previewedItem.odor ? 'Fail' : 'Pass') : 'NA' }}
                            </span>
                          </div>

                          <div id="certfinalpassfail1">
                            <span id="certfinalpassfail1sample" :style="{'color': previewedItem.passfail.final == 'FAIL' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.final }}
                            </span>
                            
                          </div>

                          <div id="certfinalpassfail2">
                            <span id="certfinalpassfail2passfail" :style="{'color': previewedItem.passfail.final == 'FAIL' ? 'red' : 'black' }">
                              {{ previewedItem.passfail.final }}
                            </span>
                          </div>
                        </div>

                        <!-- Cert Data -->
                        <div>
                          <span id="certlolnum">{{ previewedItem.lol.lolNumber }}</span>
                          <span id="certunitnum">{{ previewedItem.unit.unitNumber }}</span>
                          <span id="certdealer">{{ previewedItem.dealer.customerName }}</span>
                          <span id="certdealerid"></span>
                          <span id="certrequestedby">{{ previewedItem.requestedBy.fullName }}</span>
                          <span id="certcertid">{{ previewedItem.testNumber }}</span>
                          <span id="certsampledate">{{ previewedItem.sampleDateShow }}</span>
                          <span id="certreceivedate">{{ previewedItem.receiveDateShow }}</span>
                          <span id="certanalyzedate">{{ previewedItem.analyzeDateShow }}</span>
                          <span id="certcertissuedate">{{ previewedItem.certIssueDateShow }}</span>
                          <span id="certnotes">{{ previewedItem.notes }}</span>
                        </div>

                        <!-- Signature -->
                        <div v-if="!previewedItem.lol.unaccredited" id="certsignaturebox">
                          <img id="certsignature" :src="`/static/img/cert/${previewedItem.approvedBy.username}-signature.png`"/>
                          <div id="certnametitle">
                            <span id="certnametitledetail">{{ previewedItem.approvedBy.fullName }} / Technician</span>
                          </div>
                        </div>
                      </div>

                      <!-- NFPA Page 2 -->
                      <div id="certpg2" v-if="previewedItem.standard.standardName == 'NFPA 1989 (2019)' && previewedItem.passfail.final != 'FAIL'">
                        <div>
                          <img id="certimgpg2" src="/static/img/cert/cert-nfpa-2.png" width="100%" />
                        </div>

                        <!-- Client/Source/Date -->
                        <div>
                          <span id="certnfpaclient">{{ previewedItem.client.customerName }}</span>
                          <span id="certnfpasource">
                            <span v-if="previewedItem.source.sourceMake">
                              {{ previewedItem.source.sourceMake }}<br />
                            </span>
                            <span v-if="previewedItem.source.sourceModel">
                              {{ previewedItem.source.sourceModel }}<br />
                            </span>
                            <span v-if="previewedItem.source.sourceSN">
                              {{ previewedItem.source.sourceSN }}<br />
                            </span>
                            <span v-if="previewedItem.source.sourceDescription">
                              {{ previewedItem.source.sourceDescription }}
                            </span>
                          </span>
                          <span id="certnfpanexttestdate">
                            {{ previewedItem.nextTestDate }}
                          </span>
                        </div>

                        <!-- Signature -->
                        <div id="certsignaturebox">
                          <img id="certsignature" :src="`/static/img/cert/${previewedItem.approvedBy.username}-signature.png`"/>
                          <div id="certnametitle">
                            <span id="certnametitledetail">{{ previewedItem.approvedBy.fullName }} / Technician</span>
                          </div>
                        </div>
                      </div>

                      <!-- NFPA Page 3 -->
                      <div id="certpg3" v-if="previewedItem.standard.standardName == 'NFPA 1989 (2019)' && previewedItem.passfail.final != 'FAIL'">
                        <div id="certpg3">
                          <img id="certimgpg3" src="/static/img/cert/cert-nfpa-3.png" width="100%" />
                        </div>
                      </div>
                    </div>
                  </section>
                </vue-html2pdf>
              </div>
            </v-main>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogSendResults"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              Send Results To
            </v-card-title>

            <v-card-text>
              {{ previewedItem.requestedBy.fullName }}
              &lt;{{ previewedItem.requestedBy.email }}&gt;
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="dialogSendResults = false"
              >
                Cancel
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                @click="sendResultsTo()"
              >
                Send
                <v-icon class="ml-2">mdi-send</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <template v-slot:item.testNumber="props">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="subtitle-1"
            style="border-bottom: 1px dashed #111; cursor: pointer;"
            @click="techConfirm(props.item)"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.testNumber }}
          </span>
        </template>
        <span>Preview Cert</span>
      </v-tooltip>
    </template>

    <template v-slot:item.sampleDate="props">
      {{ props.item.sampleDate.substring(0, 19).replace('T', ' ') }}
    </template>

    <template v-slot:item.receiveDate="props">
      {{ props.item.receiveDate.substring(0, 19).replace('T', ' ') }}
    </template>

    <template v-slot:item.actions="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="black"
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </template>

        <v-list>
          <v-list-item @click="techConfirm(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-magnify</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>Preview</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item @click="editItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-list-item @click="openDialogDelete(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
  import { protectedRoute as routes } from '@/router/config'
  import TestService from "../../../services/test.service"
  import LolService from "../../../services/lol.service"
  import SourceService from "../../../services/source.service"
  import CustomerService from "../../../services/customer.service"
  import LocationService from "../../../services/location.service"
  import UnitService from "../../../services/unit.service"
  import AuthService from "../../../services/auth.service"
  import CertService from "../../../services/cert.service"
  import PdfService from "../../../services/pdf.service"
  import VueHtml2pdf from 'vue-html2pdf'
  import FileSaver from 'file-saver'
  import * as jsPDF from 'jspdf'
  
  export default {
    components: {
      VueHtml2pdf
    },

    props: {
      
    },

    data: () => ({
      search: '',
      passwordShow: false,
      message: '',
      selected: [],
      loading: false,
      sheet: false,
      tab: null,
      validationPassFail: '',
      dialog: false,
      dialogDelete: false,
      dialogEdit: false,
      dialogTechConfirm: false,
      dialogValidation: false,
      dialogPreviewCert: false,
      dialogSendResults: false,
      dialogTest: false,
      headers: [
        { text: "Test Number", value: "testNumber" },
        { text: "LOL", value: "lol.lolNumber", align: "center" },
        { text: "Company", value: "dealer.customerName", align: "center" },
        { text: "Source", value: "source.sourceName", align: "center" },
        { text: "Standard", value: "standard.standardName", align: "center" },
        { text: "Sample Date", value: "sampleDate", align: "center" },
        { text: "Receive Date", value: "receiveDate", align: "center" },
        { text: "Actions", value: "actions", align: "center", sortable: false }
      ],
      tests: [],
      lftech: {
        username: '',
        password: ''
      },
      editedIndex: -1,
      editedItem: {
        customerName: '',
      },
      previewedIndex: -1,
      previewedItem: {
        lol: {},
        dealer: {},
        requestedBy: {},
        client: {},
        location: {},
        source: {},
        unit: {},
        standard: {},
        frequency: {},
        limit: {},
        passfail: {},
        sampleshow: {},
        approvedBy: {}
      },
      defaultItem: {
        lol: {},
        dealer: {},
        requestedBy: {},
        client: {},
        location: {},
        source: {},
        unit: {},
        standard: {},
        frequency: {},
        limit: {},
        passfail: {},
        sampleshow: {},
        approvedBy: {}
      },
      pdfProgress: {
        type: Number,
        default: 0
      },
      approvalDone: false
    }),

    computed: {
      currentUser() {
        return this.$store.state.auth.user
      },

      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },

      htmlToPdfOptions() {
        return {
          margin: 0,
          image: {
            type: "png",
            quality: 0.98,
          },
          enableLinks: true,
          html2canvas: {
            scale: this.controlValue.pdfQuality,
            useCORS: true,
          },
          jsPDF: {
            unit: "in",
            format: this.controlValue.pdfFormat,
            orientation: this.controlValue.pdfOrientation,
          },
        }
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },

      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize() {
        this.checkAuth()
        this.retrieveTests()
      },

      checkAuth() {
        if (!this.$route.meta.authorize.includes(this.currentUser.roles.toString())) {
          this.$router.push('/dashboard')
        }
      },

      checkRole(role) {
        if (Array.isArray(role)) {
          var i
          for (i = 0; i < role.length; i++) {
            if (this.currentUser.roles.includes(role[i])) {
              return true
            }
            if (role[i] == 'lf') {
              if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
                return true
              }
            }
            if (role[i] == 'dealer') {
              if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
                return true
              }
            }
          }
          return false
        }

        if (role == 'lf') {
          if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
            return true
          }
        }

        if (role == 'dealer') {
          if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
            return true
          }
        }

        if (this.currentUser.roles.includes(role)) {
          return true
        } else {
          return false
        }
      },

      async retrieveTests() {
        this.loading = true
        if (this.checkRole('lf')) {
          await TestService.getAllPendingApproval()
            .then(async response => {
              this.tests = response.data || []
              var _this = this
              await this.tests.forEach(forEachTest)

              async function forEachTest(item, index) {
                await CustomerService.get(_this.tests[index].lol.customerID)
                  .then(async response => {
                    _this.tests[index].dealer = response.data || {}
                    _this.tests.splice(index, 1, _this.tests[index])

                    return new Promise(resolve => {
                      resolve('Done')
                    })
                  })

                await UnitService.getLolUnits(_this.tests[index].lolID)
                  .then(async response => {
                    _this.tests[index].unit = response.data[0] || {}
                    _this.tests.splice(index, 1, _this.tests[index])

                    return new Promise(resolve => {
                      resolve('Done')
                    })
                  })

                if (_this.tests[index].source) {
                  await LocationService.get(_this.tests[index].source.locationID)
                    .then(async response => {
                      _this.tests[index].location = response.data || {}
                      _this.tests.splice(index, 1, _this.tests[index])

                      await CustomerService.get(_this.tests[index].location.customerID)
                        .then(async response => {
                          _this.tests[index].client = response.data || {}
                          _this.tests.splice(index, 1, _this.tests[index])

                          return new Promise(resolve => {
                            resolve('Done')
                          })
                        })

                      return new Promise(resolve => {
                        resolve('Done')
                      })
                    })
                } else {
                  _this.tests[index].source = {
                    sourceID: null,
                    sourceMake: "",
                    sourceModel: "",
                    sourceSN: "",
                    sourceDescription: "",
                  }
                  _this.tests[index].location = {
                    locationID: null,
                    locationName: ""
                  }
                  _this.tests[index].client = {
                    customerID: null,
                    customerName: ""
                  }
                  _this.tests[index].frequency = {
                    frequencyID: null,
                    frequencyName: ""
                  }
                }
              }

              return new Promise(resolve => {
                resolve('Done')
              })
            })
            .catch(e => {
              console.log(e)
              window._LOL2P.$emit('SHOW_SNACKBAR', {
                  text: 'There was an error retrieving tests',
                  color: 'error'
                })
            })

          if (this.$route.query.testnumber) {
            this.search = this.$route.query.testnumber
          }
        } else {
          this.$router.push('/dashboard')
        }
        this.loading = false
      },

      updateTest() {
        var updateItem = {
          testID: this.previewedItem.testID
        }

        Object.keys(this.previewedItem).forEach(async key => {
          if (this.previewedItem[key] == 'ND') { this.previewedItem[key] = null }
          if (this.tests[this.previewedIndex][key] != this.previewedItem[key]) { updateItem[key] = this.previewedItem[key] }
        })

        TestService.update(updateItem.testID, updateItem)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The test was updated successfully',
              color: 'success'
            })

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      deleteTest() {
        TestService.delete(this.previewedItem.testID)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The test was deleted successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      createCert() {
        this.certCreate = {
          dealerID: this.previewedItem.dealer.customerID,
          clientID: this.previewedItem.client.customerID,
          locationID: this.previewedItem.location.locationID,
          sourceID: this.previewedItem.sourceID,
          lolID: this.previewedItem.lolID,
          testID: this.previewedItem.testID,
          standardID: this.previewedItem.standardID,
          frequencyID: this.previewedItem.frequencyID,
          requestedByID: this.previewedItem.requestedByID,
          approvedByID: this.previewedItem.approvedBy.userID,
          certificateNumber: this.previewedItem.testNumber,
          sampleDate: this.previewedItem.sampleDate,
          receiveDate: this.previewedItem.receiveDate,
          analyzeDate: this.previewedItem.analyzeDate,
          approvalDate: this.previewedItem.approvalDate,
          certIssueDate: this.previewedItem.certIssueDate,
        }

        let certificateID = null
        
        CertService.create(this.certCreate)
          .then(response => {
            // window._LOL2P.$emit('SHOW_SNACKBAR', {
            //   text: 'Success! The certificate was created successfully',
            //   color: 'success'
            // })

            certificateID = response.data.certificateID
            this.previewedItem.certificateID = certificateID
            // this.dialogPreviewCert = false
            if (this.previewedItem.standard.standardName != "Validation") {
              this.dialogSendResults = true
            }
            this.retrieveTests()
            this.approvalDone = true
          })
          .catch(e => {
            console.log(e)
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'There was an error creating the certificate',
              color: 'error'
            })
          })

        return certificateID
      },

      goToLocations() {
        
      },

      goToClients() {
        
      },

      goToTests() {
        
      },

      clearSheet() {
        this.editedItem.customerName = ""
        this.editedIndex = -1
        this.tab = 1
      },

      techConfirm(item) {
        this.dialogTechConfirm = true
        this.previewItem(item)
      },

      techConfirmed() {
        AuthService.checkTech(this.lftech)
          .then(response => {
            if (response.roles.includes('ROLE_LFADMIN') || response.roles.includes('ROLE_LFTECH')) {
              if (this.previewedItem.standard.standardName != "Validation") {
                this.dialogPreviewCert = true
              } else {
                this.dialogValidation = true
              }
              this.closeTech()
              this.previewedItem.approvedBy = response
            } else {
              this.snackbar('Error! Sorry, this function is only for LF users', 'error')
            }
          })
          .catch(e => {
            console.log(e)
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'Incorrect credentials!',
              color: 'error'
            })
          })
      },

      closeTech() {
        this.lftech.username = ''
        this.lftech.password = ''
        this.dialogTechConfirm = false
        this.techPIN = ''
      },

      async validationSelect(selection) {
        this.validationPassFail = selection
        await this.parseStandardFinal()
        this.dialogPreviewCert = true
        this.dialogValidation = false
      },

      async previewItem(item) {
        item.approvedBy = {}
        item.limit = {}
        item.passfail = {}
        item.sampleshow = {}
        this.previewedIndex = this.tests.indexOf(item)
        this.previewedItem = Object.assign({}, item)

        let date = new Date()
        this.previewedItem.sampleDateShow = this.previewedItem.sampleDate.substring(0, 10)
        this.previewedItem.receiveDateShow = this.previewedItem.receiveDate.substring(0, 10)
        this.previewedItem.analyzeDate = date.getTime()
        this.previewedItem.analyzeDateShow = date.toISOString().split('T')[0]
        this.previewedItem.certIssueDate = date.getTime()
        this.previewedItem.certIssueDateShow = date.toISOString().split('T')[0]
        this.previewedItem.approvalDate = date.getTime()

        if (this.previewedItem.standard.standardName != 'NFPA 1989 (2019)' && this.previewedItem.standard.standardName != 'Validation') {
          this.previewedItem.nextTestDate = new Date(date.setMonth(date.getMonth() + (12 / this.previewedItem.frequency.testsPerYear))).toISOString().split('T')[0]
        } else {
          // Forced quarterly next test date for NFPA 1989
          this.previewedItem.nextTestDate = new Date(date.setMonth(date.getMonth() + (12 / 4))).toISOString().split('T')[0]
        }

        this.previewedItem.notes = item.testNotes
        this.approvalDone = false
        await this.parseStandard()
      },

      async parseStandard() {
        await this.parseStandardLimits('oxygen')
        await this.parseStandardLimits('nitrogen')
        await this.parseStandardLimits('carbonDioxide')
        await this.parseStandardLimits('carbonMonoxide')
        await this.parseStandardLimits('methane')
        await this.parseStandardLimits('dewPoint')
        await this.parseStandardLimits('waterVapor')
        await this.parseStandardLimits('nitrogenDioxide')
        await this.parseStandardLimits('nitricOxide')
        await this.parseStandardLimits('sulfurDioxide')
        await this.parseStandardLimits('nitrousOxide')
        await this.parseStandardLimits('thc')
        await this.parseStandardLimits('haloSolvents')
        await this.parseStandardLimits('vhc')
        await this.parseStandardLimits('vhhc')
        await this.parseStandardLimits('oilParticles')
        await this.parseStandardFinal()
      },

      parseStandardLimits(analyte) {
        let sample = this.previewedItem[analyte]
        let limitLow = this.previewedItem.standard[analyte + 'Low']
        let limitHigh = this.previewedItem.standard[analyte + 'High']

        let limit = ''
        let passfail = ''
        let sampleshow = 0

        if (limitLow && limitHigh) {
          if (limitLow == -9999 && limitHigh == 9999) {
            limit = 'NA'
            passfail = 'NA'
          } else if (limitLow == -9999) {
            limit = '&lt; ' + limitHigh
            passfail = (sample < limitLow || sample > limitHigh) ? 'Fail' : 'Pass'
          } else if (limitHigh == 9999) {
            limit = '&gt; ' + limitLow
            passfail = (sample < limitLow || sample > limitHigh) ? 'Fail' : 'Pass'
          } else {
            limit = limitLow + ' - ' + limitHigh
            passfail = (sample < limitLow || sample > limitHigh) ? 'Fail' : 'Pass'
          }
          sampleshow = 1
        } else {
          limit = 'NA'
          passfail = 'NA'
          sampleshow = 0
        }

        if (sample <= 0 && analyte != "dewPoint") {
          this.previewedItem[analyte] = 'ND'
        } else {
          this.previewedItem[analyte] = parseFloat(this.previewedItem[analyte]).toFixed(1)
        }

        this.previewedItem.limit[analyte] = limit
        this.previewedItem.passfail[analyte] = passfail
        this.previewedItem.sampleshow[analyte] = sampleshow

        return new Promise(resolve => {
          resolve('Done')
        })
      },

      parseStandardFinal() {
        let passfail = ''

        if (this.previewedItem.passfail.oxygen == 'Fail') {
          passfail = 'FAIL'
        } 
        if (this.previewedItem.passfail.nitrogen == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.carbonDioxide == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.carbonMonoxide == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.methane == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.dewPoint == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.waterVapor == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.nitrogenDioxide == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.nitricOxide == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.sulfurDioxide == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.nitrousOxide == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.thc == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.haloSolvents == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.vhc == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.vhhc == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.passfail.oilParticles == 'Fail') {
          passfail = 'FAIL'
        }
        if (this.previewedItem.standard.odor != null && this.previewedItem.odor > 0) {
          passfail = 'FAIL'
        }
        if (passfail != 'FAIL') {
          this.previewedItem.standard.standardName == 'Validation' ? passfail = this.validationPassFail : passfail = 'PASS'
        }

        this.previewedItem.passfail.final = passfail

        return new Promise(resolve => {
          resolve('Done')
        })
      },

      // editItem(item) {
      //   this.editedIndex = this.tests.indexOf(item)
      //   this.editedItem = Object.assign({}, item)
      //   this.sheet = true
      // },

      // deleteItem(item) {
      //   this.editedIndex = this.tests.indexOf(item)
      //   this.editedItem = Object.assign({}, item)
      //   this.dialogDelete = true
      // },

      // deleteItemConfirm() {
      //   this.tests.splice(this.editedIndex, 1)
      //   this.deleteTest()
      //   this.closeDelete()
      // },

      close() {
        this.dialogPreviewCert = false
        this.$nextTick(() => {
          this.previewedItem = Object.assign({}, this.defaultItem)
          this.previewedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.previewedItem = Object.assign({}, this.defaultItem)
          this.previewedIndex = -1
        })
      },

      async save() {
        if (this.previewedIndex > -1) {
          this.updateTest()
          Object.assign(this.tests[this.previewedIndex], this.previewedItem)

          this.previewedIndex = this.tests.indexOf(this.tests[this.previewedIndex])
          this.previewedItem = Object.assign({}, this.tests[this.previewedIndex])
          await this.parseStandard()
        }
        // this.close()
        this.dialogEdit = false
      },

      openDialogDelete(item) {
        this.previewItem(item)
        this.dialogDelete = true
      },

      confirmDelete() {
        this.previewedItem.lolID = null
        this.updateTest()
        this.delete()
      },

      delete () {
        if (this.previewedIndex > -1) {
          this.tests.splice(this.previewedIndex, 1)
          this.deleteTest()
        }
        this.closeDelete()
      },

      generateReport() {
        this.$refs.lolCertificate.generatePdf()
      },

      async hasDownloaded(blob) {
        const pdf = new File([blob], `${this.previewedItem.testNumber}.pdf`, {
          type: "application/pdf",
        })

        const fd = new FormData()
        fd.append('pdf', pdf, pdf.name)

        PdfService.create(fd)
          .then(res => {
            this.snackbar('Success! The certificate was stored successfully', 'success')
          })
          .catch(e => {
            console.log(e)
            this.snackbar('Error! There was an error storing the certificate.', 'error', '6000')
          })

        this.createCert()
      },

      sendResultsTo() {
        PdfService.sendResults(this.previewedItem.certificateID)
          .then(response => {
            this.snackbar('Success! Results sent successfully', 'success', '6000')
            this.dialogSendResults = false
          })
          .catch(e => {
            console.log(e)
            this.snackbar('Error! Error sending results', 'error', '0')
          })
      },

      onProgress(pdfProgress) {
        this.pdfProgress = pdfProgress
      },

      timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      },

      downloadCert(certificateNumber) {
        var pdfURL = `${process.env.VUE_APP_BASE_URL}/pdfs/${certificateNumber}`

        fetch(pdfURL).then(resp => resp.arrayBuffer()).then(resp => {
          const file = new Blob([resp], {type: 'application/pdf'})

          const fileURL = URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = fileURL
          link.download = `${certificateNumber}.pdf`
          link.click()
        })

        // window.open(`${process.env.VUE_APP_BASE_URL}/pdfs/${certificateNumber}`)
      },

      snackbar(message, color, timeout) {
        window._LOL2P.$emit('SHOW_SNACKBAR', {
          text: message,
          color: color,
          timeout: timeout
        })
      },
    },
  }
</script>

<style>
@import '/static/css/certgenerate.css';
@import '/static/css/certpreview.css';
</style>